export default __webpack_public_path__ + "static/11.03-7941852a84f412eff7214ffb18ec9229.png";